<template>
  <div v-show="p_options.length>0" :style="[{'top':p_cssTop+'px'},{'left':p_cssLeft+'px'}]" class="divPicker">
    <!--Y:{{ p_cssTop }}<br>
    X:{{ p_cssLeft }}---->
    <table class="tbList">
      <tr v-for="(mm,idx) in p_options" :key="idx" :class="idx===p_idx?'trPk':''" @click="a_pickup(mm)">
        <td>{{ mm.fcode }}</td>
        <td>{{ mm.fname }}</td>
      </tr>
    </table>
    <!---
    <el-autocomplete
      v-model="p_model"
      :fetch-suggestions="mkValues"
      :trigger-on-focus="true"
      clearable
      size="mini"
      value-key="fname"
      @select="picked"/>---><!--@clear="blurForBug()"-->
  </div>
</template>
<script type="text/javascript">

export default{
  name: 'COption',
  props: {
    p_cssTop: {
      type: Number,
      default: 100
    },
    p_cssLeft: {
      type: Number,
      default: 100
    },
    p_options: {
      type: Array,
      default: () => {
        return []
      }
    },
    p_idx: {
      type: Number,
      default: 0
    },
    a_pickup: {
      type: Function,
      default: null
    }
  },
  data: function() {
    return {
      bbShow: true }
  },
  methods: {
    prt(a, b) {
      console.log(`c3_tools.01_picker.${a}`, b)
    },
    mkLike(val) {
      this.prt('mkLike', val)
      return this.$keys().like + val + this.$keys().like
    }
  }
}
</script>
<style>
.divPicker{
  z-index: 40;
  width: 300px;
  height: auto;
  max-height: 300px;
  left: 100px;
  background-color: rgb(247, 255, 245);
  display: block;
  position: absolute;
  border: 1px solid rgba(55, 84, 107, 0.623);
  padding: 3px;
  border-radius: 3px;
}
.trPk{
  background-color: rgb(60, 255, 0);
}
</style>



// WEBPACK FOOTER //
// src/comps/c3_tools/01_picker.vue